<mat-form-field
    class="vc-chips-autocomplete-container vc-mat-form-field"
    appearance="fill"
    [class.mat-form-field-disabled]="readonly || disabled"
    [class.mat-form-field-invalid]="!valid && touched">
    <mat-label>{{ label }}</mat-label>
    <mat-chip-grid #chipList [attr.aria-label]="label">
        @for (val of values; track val) {
            <mat-chip-row color="accent" (removed)="remove(val)">
                {{ itemRenderer(val) }}
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
        }
        <input
            #autocompleteInput
            [(ngModel)]="filterValue"
            [placeholder]="placeholder"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [attr.aria-invalid]="!valid"
            [attr.aria-describedby]="ariaDescribedBy"
            [readonly]="readonly"
            [disabled]="disabled"
            [required]="required"
            (blur)="touched = true"
            (ngModelChange)="inputValueChanges()"
            (matChipInputTokenEnd)="add($event)" />
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectValue($event)">
        @for (value of filteredOptions; track value) {
            <mat-option [value]="value">
                {{ itemRenderer(value) }}
            </mat-option>
        }
    </mat-autocomplete>
    @if (!valid && touched) {
        <mat-hint class="mat-error vc-error-message">{{ errorMessage }}</mat-hint>
    }
</mat-form-field>
